"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Kentaro Kawakatsu
 */
var TouchEventName = /** @class */ (function () {
    function TouchEventName() {
    }
    TouchEventName.TOUCH_START = "touchstart";
    TouchEventName.TOUCH_MOVE = "touchmove";
    TouchEventName.TOUCH_END = "touchend";
    return TouchEventName;
}());
exports.default = TouchEventName;



//////////////////
// WEBPACK FOOTER
// ./src/ts/myLib/enum/events/TouchEventName.ts
// module id = 17
// module chunks = 0